////Clinical Event 상세화면

import React, {useEffect, useState} from "react";
import InputUnitText from "../../components/InputText/InputUnitText";
import DatePicker from "../../components/DatePicker/DatePicker";
import {calcQcaDs, dateToYMD, ymdToDate} from "./REGComUtil";
import Table from "../../components/Table/Table";
import SelectBox from "../../components/SelectBox/SelectBox";

const DynamicTable = (props) => {

    const getDynamicCode = (key, index) => {
        return index === 1 ? key : `M${String(parseInt(key.slice(1)) + (index - 1) * 11).padStart(5, '0')}`;
    };
    const getNextItemCd = (itemCd, offset) => {
        const prefix = itemCd.charAt(0); // 첫 번째 알파벳
        const numberPart = parseInt(itemCd.slice(1), 10); // 숫자 5자리 변환
        const newNumber = (numberPart + offset).toString().padStart(5, '0'); // 증가 후 5자리 유지
        return prefix + newNumber;
    };

    const item1  = getDynamicCode(props.startCd, props.index);
    const item2  = getDynamicCode(getNextItemCd(props.startCd,1), props.index);
    const item3  = getDynamicCode(getNextItemCd(props.startCd,2), props.index);
    const item4  = getDynamicCode(getNextItemCd(props.startCd,3), props.index);
    const item5  = getDynamicCode(getNextItemCd(props.startCd,4), props.index);
    const item6  = getDynamicCode(getNextItemCd(props.startCd,5), props.index);
    const item7  = getDynamicCode(getNextItemCd(props.startCd,6), props.index);
    const item8  = getDynamicCode(getNextItemCd(props.startCd,7), props.index);
    const item9  = getDynamicCode(getNextItemCd(props.startCd,8), props.index);
    const item10 = getDynamicCode(getNextItemCd(props.startCd,9), props.index);
    const item11 = getDynamicCode(getNextItemCd(props.startCd,10), props.index);

    /* 2026-03-04 요청사항
     * 1.별도 예외처리([요청:A0022]수정요청에 의하여 2026-03-05 추가함) :
     *  - Clinical Event 이상반응-1 종료일의 경우 결과영역의 상태값이 3,4,6 일때는 비활성화
     * 
     */
    const [isItem3ReadOnly, setIsItem3ReadOnly] = useState(false);
    const item10Change = (itemCd, value) => {

        props.setDtlValue(itemCd, value);
        item3setting(value);
    }
    const item3setting = (item10value) => {
        if(item10value==='3' || item10value==='4' || item10value==='6'){
            props.setDtlValue(item3, "");
            setIsItem3ReadOnly(true);
        }else{
            setIsItem3ReadOnly(false);
        }
    }

    useEffect(() => {
        item3setting(props.getDtlValue(item10));
    }, []);


    return (
        <>
            <div style={{marginTop:"10px"}}>▶ 이상반응 - {props.index}  </div>

            <Table key={props.index} variant="default" rowCnt={4} colSize={["20%", "20%", "50%", "50%", "40%", "50%"]}
                   rowSize="56px">
                <div>이상사례명</div>
                <div>
                    <InputUnitText type="text" value={props.getDtlValue(item1)}
                                   unit="" maxLength={100} width={"260px"}
                                   onChange={(value) => props.setDtlValue(item1, value)}/>
                </div>
                <div>시작일</div>
                <div>
                    <DatePicker selDate={ymdToDate(props.getDtlValue(item2))}
                                dateFormat="yyyy-MM-dd"
                                onChange={(date) => props.setDtlValue(item2, dateToYMD(date))}/>
                </div>
                <div>종료일</div>
                <div>
                    <DatePicker selDate={ymdToDate(props.getDtlValue(item3))}
                                dateFormat="yyyy-MM-dd"  isDisabled={isItem3ReadOnly}
                                onChange={(date) => props.setDtlValue(item3, dateToYMD(date))}/>
                </div>
                <div>중증도</div>
                <div>
                    <SelectBox options={props.getOptionList(item4)}
                               valueKey="value" labelKey="label"
                               value={props.getDtlValue(item4)}
                               onChange={(val) => props.setDtlValue(item4, val)}
                               width="90%"/>
                </div>
                <div>SAE여부</div>
                <div>
                    <SelectBox options={props.getOptionList(item5)}
                               valueKey="value" labelKey="label"
                               value={props.getDtlValue(item5)}
                               onChange={(val) => props.setDtlValue(item5, val)}
                               width={'90%'}/>
                </div>
                <div>SAE종류</div>
                <div>
                    <SelectBox options={props.getOptionList(item6)}
                               valueKey="value" labelKey="label"
                               value={props.getDtlValue(item6)}
                               onChange={(val) => props.setDtlValue(item6, val)}
                               width={'90%'}/>
                </div>
                <div>연구자 인지일</div>
                <div>
                    <DatePicker selDate={ymdToDate(props.getDtlValue(item7))}
                                dateFormat={'yyyy-MM-dd'}
                                onChange={(date) => props.setDtlValue(item7, dateToYMD(date))}/>
                </div>
                <div>연구용 의료기기와의 <br/>인과관계</div>
                <div>
                    <SelectBox options={props.getOptionList(item8)}
                               valueKey="value" labelKey="label"
                               value={props.getDtlValue(item8)}
                               onChange={(val) => props.setDtlValue(item8, val)}
                               width={'90%'}/>
                </div>
                <div>치료내용</div>
                <div>
                    <SelectBox options={props.getOptionList(item9)}
                               valueKey="value" labelKey="label"
                               value={props.getDtlValue(item9)}
                               onChange={(val) => props.setDtlValue(item9, val)}
                               width={'90%'}/>
                </div>
                <div>결과</div>
                <div className={'col_merge'}>
                    <table style={{width: "98%", marginTop:"8px", marginBottom:"10px"}}>
                        <tbody>
                        <tr>
                            <td width={"40px"}>
                                상태
                            </td>

                            <td style={{width: "250px"}}>
                                <SelectBox options={props.getOptionList(item10)}
                                           valueKey="value" labelKey="label"
                                           value={props.getDtlValue(item10)}
                                           //onChange={(val) => props.setDtlValue(item10, val)}
                                           onChange={(val) => item10Change(item10, val)}
                                           width={'30%'}/>

                            </td>

                        </tr>
                        <tr>
                            <td> 상세내용 </td>
                            <td>
                                <textarea
                                    style={{height: "130px", width: "800px", marginTop:"20px"}}
                                    name="userDscr" maxLength={300}
                                    value={props.getDtlValue(item11)}
                                    unit={""}
                                    onChange={e => props.setDtlValue(item11, e.target.value)}
                                />

                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>

            </Table>

        </>
    );
};

export default DynamicTable;
